import { BCMSDate, BCMSDefaultModel, BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import TransferActivityPage, { getDefaultPageData, getDefaultPageUI } from "components/pages/TransferActivityPage";
import ScheduledTransfersPage from "components/pages/TransferActivityPage/components/ScheduledTransfersPage";
import Classes, { Account, TransferTransaction } from "model";

/**
 * @name CaptureTransfersTransfersDetails
 * @returns {React.Component}
 * @description The capture component for the transfer activity page
 * showing the scheduled transfers and the first transfer showing details.
 * This capture is used in the following capture groups:
 * "Transfers - Recurring" (abi22), "Transfers" (mabi23).
 */
export default function CaptureTransfersTransfersDetails(props) {
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, globalController);
    const checkingAccount = Account.getDefaultBrandedAccountByType("checking");
    const savingsAccount = Account.getDefaultBrandedAccountByType("savings");
    // START: Add a new transfer as the most recent transfer.
    let transfers = TransferTransaction.initAll().filter(transfer => transfer.status === "scheduled", []);
    const newTransfer = BCMSDefaultModel.transferTransaction();
    // Set a new id of "43" for this new transfer. 
    // It could be for a consumer or business account.
    newTransfer.id = "43";
    newTransfer.amount.amount = 100;
    newTransfer.from = checkingAccount.id; // may need to be adjusted to use Account.initByType("0"). "initByType" currently does not work with class "TransferTransaction".
    newTransfer.to = savingsAccount.id; // may need to be adjusted to use Account.initByType("3"). "initByType" currently does not work with class "TransferTransaction".
    newTransfer.paymentOption = "Payment Due";
    newTransfer.schedule = "Recurring";
    newTransfer.frequency = "Monthly";
    newTransfer.duration = "No End Date";
    newTransfer.startDate = BCMSDate.init();
    newTransfer.estimatedDeliveryDate = BCMSDate.init();
    newTransfer.description = "Sample";
    transfers = [ newTransfer, ...transfers ];
    // END: Add a new transfer as the most recent transfer.

    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
    .update(["scheduledTransfers"], transfers)
    .submit();

    // Initalize a new instance of BCMSStateManagerCRUD using the default page ui
    // updating hte content, scheduledTransfers and Accordion properties
    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
        // Sets the component to be used for the content
        .update([ "content" ], ScheduledTransfersPage)
        // Sets the tab to be selected
        .update([ "scheduledTransfers", "isActive" ], true)
        .update([ "Accordion_43" ], { isActive: true })
        .update([ "Mobile_Accordion_43" ], { isActive: true })
        .submit();

    // Return the TransferActivityPage passing the ui variable
    return <TransferActivityPage data={ data } ui={ ui } />
}